// extracted by mini-css-extract-plugin
module.exports = {"hidden":"companyMessage_hidden__PIPpo","textEmphasis":"companyMessage_textEmphasis__6bJ9p","wrap":"companyMessage_wrap__GUvvU","contentArea":"companyMessage_contentArea__mWIhL"};